'use strict';

import angular from 'angular';

export default angular.module('storageApp.filters.storage', [])
  .filter('renderStorage', function(Storage, $sce){
    'ngInject';

    var getCatById = function(id){
      return Storage.getCategories()
        .filter(category => {
          return id == category._id;
        }).shift();
    };

    var getFullPath = function(category) {
      var names = [];

      while(category){
        names.push(category.name);
        category = getCatById(category.parentId);
      }

      return names.reverse().join('/');
    };

    var getCatPath = function(id){
      var category = getCatById(id);
      
      if( ! category){
        return;
      }

      return getFullPath(category);
    };

    var getById = function(id){
      return Storage.getStorages()
        .filter(storage => {
          return id == storage._id;
        }).shift();
    };

    return function (input, raw) {
      var storage = getById(input);
      
      if( ! storage){
        return;
      }

      var fullPath = getCatPath(storage.categoryId) + '/' + storage.name;

      if(raw){
        return fullPath;
      }

      return $sce.trustAsHtml('<span title="' + fullPath + '">' + storage.name + '</span>');
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/filters/storage.js